<template>
  <!---全体を囲む--->
  <div>
    <!-- メイン画面 -->
    <div v-if="isReadyToDraw" class="content-wrapper">
      <!-- 施設情報表示 -->
      <TheFacilityCard
        v-if="rental_car.Office"
        :background-img-u-r-l="rental_car.Office.Supplier.img"
        :list-item1="rental_car.Office.Supplier.name"
        :list-item3="rental_car.Office.name"
        :button1-action="gotoPlaceRentalCar"
        :button2-action="goToDetailRentalCar"
      />
      <!-- 施設情報表示 -->

      <!-- index画面の描画ローディング -->
      <ItemDialogForIndexPage v-else />
    </div>
    <!-- メイン画面 -->

    <!-- isReadyToDrawがtrueになるまで -->
    <FacePhraseForIndexPage
      v-else
      phrase="周辺にご案内できる施設はありません"
    />
  </div>
  <!---全体を囲む--->
</template>

<script>
import { mapGetters } from "vuex";

export default {
  async mounted() {
    if (this.$store.getters["common/device"] == "BROWSER") {
      try {
        const info = await this.$store.dispatch("rental_car/getRentalCar", {
          geo: "43.06,141.35",
        });
        window.jcSetRentalCarInfo(info);
      } catch (err) {
        window.jcSetRentalCarInfo("");
      }
    } else {
      // 周辺・カーシェア・レンタカーでページ描画完了をマップWebviewへ知らせる関数
      this.ncPageReady();
    }
  },
  methods: {
    gotoPlaceRentalCar() {
      this.ncGotoPlaceRentalCar(this.rental_car);
    },
    async goToDetailRentalCar() {
      await this.ncSetPlaceInfoRentalCar(this.rental_car);
      await this.$router.push({
        name: "RentalCarDetail",
        params: {
          index: 0,
        },
        query: { language: this.$store.getters["common/lang"] },
      });
    },
  },
  computed: {
    isReadyToDraw() {
      return this.rental_car;
    },
    ...mapGetters("rental_car", ["rental_car"]),
  },
};
</script>
